// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__KBAsA","subheader":"ReorderModal_subheader__2-T4B","listWrap":"ReorderModal_listWrap__INMR8"};